var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      class: _vm.svgClass,
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        height: _vm.height,
        width: _vm.width,
        viewBox: _vm.viewBox
          ? _vm.viewBox
          : "0 0 " + _vm.icon.width + " " + _vm.icon.height,
        fill: "currentColor"
      }
    },
    [_c("path", { attrs: { d: _vm.icon.path } })]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-448da7c3", { render: render, staticRenderFns: staticRenderFns })
  }
}